import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { NavLink } from "react-router-dom";
import { FaBars, FaX } from "react-icons/fa6";
import { FaSignOutAlt, FaHome } from "react-icons/fa";

const Navbar = ({ businessId, publicName }) => {
  const { business, businessToken, user, userToken, logout, businessLogout, adminBusiness, businessAdminToken} = useAuth();
  const [open, setOpen] = useState(false);
  const [businessID, setBusinessID] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    if (adminBusiness && businessAdminToken) {

      setBusinessID(adminBusiness._id);
      setLoading(false);
    } else if (business && businessToken) {

      setBusinessID(business._id);
      setLoading(false);
    } else {

      setLoading(false); // i když nejsme přihlášení, tak už je zkontrolováno
    }
  }, [adminBusiness, businessAdminToken, business, businessToken]);

  
  const handleOpen = () => {
    setOpen(!open);
  };

  const getNavClass = ({ isActive }) => (isActive ? "nav-link active" : "nav-link");

  
  // Loading stav
  if (loading) {
    return <div className="loading-spinner center" /> // nebo tady může být třeba loader animace
  }

  // Funkce na hlavičku
  const renderHeaderName = () => {
    if (businessId) {
      return (
        <NavLink to={`/business/public/${businessId}`} className="link-name">
          <h2>{publicName}</h2>
        </NavLink>
      );
    }
    return (
      <NavLink to={`/`} className="link-name">
        <h2>{process.env.REACT_APP_URL_NAME}</h2>
      </NavLink>
    );
  };

  // Render linků pro nepřihlášené
  const renderPublicLinks = () => (
    <>
      {businessId ? (
        <>
          <NavLink to={`/business/public/${businessId}/reservation`} className={getNavClass} end>
            Rezervace termínu
          </NavLink>
          <NavLink to="/login-choice" className={getNavClass} end>Přihlášení</NavLink>
          <NavLink to="/registration-choice" className={getNavClass} end>Registrace</NavLink>
        </>
      ) : (
        <>
          <NavLink to="/" className={getNavClass} end>Domů</NavLink>
          <NavLink to="/login-choice" className={getNavClass} end>Přihlášení</NavLink>
          <NavLink to="/registration-choice" className={getNavClass} end>Registrace</NavLink>
          <NavLink to="/contact" className={getNavClass} end>Kontakt</NavLink>
        </>
      )}
    </>
  );

  const renderAdminBusinessLinks = () => (
    <>
    <NavLink to={`/business/global-main-page/${businessID}`} className={getNavClass} end><FaHome size={25} /></NavLink>
      <NavLink to="/business/admin-profile" className={getNavClass} end>Profil</NavLink>
      <NavLink to="/business/admin-profile/AdminPaymentform" className={getNavClass} end>Správa předplatného</NavLink>
      <NavLink to="/contact" className={getNavClass} end>Kontakt</NavLink>
      <button className="logout-button" onClick={businessLogout}>
        <FaSignOutAlt className="logout-icon" />
      </button>
    </>
  );

  // Render linků pro business uživatele
  const renderBusinessLinks = () => (
    <>
      <NavLink to="/business/profile" className={getNavClass} end>Profil</NavLink>
      <NavLink to={`/business/public/${businessID}/reservation`} className={getNavClass} end>Kalendář</NavLink>
      <NavLink to={`/business/public/${businessID}`} className={getNavClass} end>Veřejný profil</NavLink>
      <NavLink to="/business/profile/reservations" className={getNavClass} end>Správa rezervací</NavLink>
      <NavLink to="/business/profile/paymentform" className={getNavClass} end>Správa předplatného</NavLink>
      <NavLink to="/contact" className={getNavClass} end>Kontakt</NavLink>
      <button className="logout-button" onClick={businessLogout}>
        <FaSignOutAlt className="logout-icon" />
      </button>
    </>
  );

  // Render linků pro běžného uživatele
  const renderUserLinks = () => (
    <>
      {businessId && (
        <NavLink to={`/business/public/${businessId}/reservation`} className={getNavClass}>
          Rezervace termínu
        </NavLink>
      )}
      <NavLink to="/profile" className={getNavClass} end>Profil</NavLink>
      <NavLink to="/reservation" className={getNavClass} end>Moje rezervace</NavLink>
      <NavLink to="/contact" className={getNavClass} end>Kontakt</NavLink>
      <button className="logout-button" onClick={logout}>
        <FaSignOutAlt className="logout-icon" />
      </button>
    </>
  );

  return (
    <div className="header-menu">
      {business && businessToken ? (
        <NavLink to="/business/profile" className="link-name">
          <h2>{business.name}</h2>
        </NavLink>
      ) : (
        renderHeaderName()
      )}

      <div className="burger-icon" onClick={handleOpen}>
        {open ? <FaX size={24} /> : <FaBars size={24} />}
      </div>

      <nav className={`nav-links ${open ? "open" : ""}`}>
  {business && businessToken
    ? renderBusinessLinks()
    : adminBusiness && businessAdminToken
    ? renderAdminBusinessLinks()
    : user && userToken
    ? renderUserLinks()
    : renderPublicLinks()}
</nav>
    </div>
  );
};

export default Navbar;